import Alpine from 'alpinejs';
import map from '../../views/components/Map/Map';
import infoSheet from '../../views/components/InfoSheet/InfoSheet';
import timeline from '../../views/components/Timeline/Timeline';
import timelineDesktop from '../../views/components/Timeline/TimelineDesktop';
import intro from '../../views/components/Intro/Intro';
import shareDialog from '../../views/components/ShareDialog/ShareDialog';
import filter from '../../views/components/Filter/Filter';
import candidates from '../../views/components/Candidates/Candidates';
import router from './router';

Alpine.data('router', router);

// eslint-disable-next-line no-undef
Alpine.store('config', config);
Alpine.store('global', {
  tickInterval: null,
  totalInvestmentAmount: 0,
  skipAnimation: false,
  showYear: 9999,
  numVisibleMarkers: 0,
  isIntroHidden: false,
  isMapVisible() {
    return this.isIntrohidden;
  },
  setInvestmentAmount(target) {
    clearInterval(this.tickInterval);
    const interval = 1;
    let step = 1000000;
    this.tickInterval = setInterval(() => {
      if (this.skipAnimation) {
        this.totalInvestmentAmount = target;
        this.skipAnimation = false;
      }

      if (this.totalInvestmentAmount === target) {
        this.totalInvestmentAmount = target;
        clearInterval(this.tickInterval);
      } else if (this.totalInvestmentAmount < target) {
        if (this.totalInvestmentAmount + step > target) {
          step = target - this.totalInvestmentAmount;
        }
        this.totalInvestmentAmount += step;
      } else {
        if (this.totalInvestmentAmount - target < step) {
          step = this.totalInvestmentAmount - target;
        }

        this.totalInvestmentAmount -= step;
      }
    }, interval);
  },
  filters: {
    construction: true,
    environment: true,
    educulture: true,
    future: true,
  },
});
Alpine.store('router', {
  id: null,
  section: 'map',
});

Alpine.data('map', map);
Alpine.data('infoSheet', infoSheet);
Alpine.data('timeline', timeline);
Alpine.data('timelineDesktop', timelineDesktop);
Alpine.data('intro', intro);
Alpine.data('shareDialog', shareDialog);
Alpine.data('filter', filter);
Alpine.data('candidates', candidates);

Alpine.start();

window.Alpine = Alpine;
